var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"add-button",on:{"click":_vm.goToCreateTimeRow}},[_c('img',{attrs:{"src":require("../assets/add.svg"),"alt":"timesheet","height":"25px"}})])}
var staticRenderFns = []

export { render, staticRenderFns }